import Vue from 'vue';
import nationalities from '@/data/nationalities';
import playerPositions from '@/data/playerPositions';
import differenceInYears from 'date-fns/differenceInYears';
import weekDays from '@/data/weekDays';
import months from '@/data/months';
import parseISO from 'date-fns/parseISO';
import { toFixedTwoDigitsMax } from '@/utils/misc';
import { ceilMod } from '@/utils/maths';
import format from 'date-fns/format';
import { es } from 'date-fns/locale';
import esLocale from 'date-fns/locale/es';

const secondsInHour = 60 * 60;

// ceil decimals
Vue.filter('ceilMod', (num, decQty = 2) => {
  return ceilMod(num, decQty);
});

// nationalityId must be an integer
Vue.filter('toNationalityName', nationalityId => {
  return nationalityId ? nationalities[nationalityId] : '';
});

// playerPositionId must be an integer
Vue.filter('toPlayerPositionName', playerPositionId => {
  return playerPositionId ? playerPositions[playerPositionId] : '';
});

// dateOfBirth must be a valid date format string
Vue.filter('toAge', dateOfBirth => {
  return dateOfBirth ? differenceInYears(new Date(), new Date(dateOfBirth)) : '';
});

// date must be a valid date format string
Vue.filter('toDayOfWeek', date => {
  return weekDays[parseISO(date).getDay()];
});

// date must be a valid date format string
Vue.filter('toDayOfMonth', date => {
  return parseISO(date).getDate();
});

// date must be a valid date format string
Vue.filter('toMonth', date => {
  return months[parseISO(date).getMonth()];
});

// Time string must be in format hh:mm:ss 19:00:00
Vue.filter('removeSecondsFromTime', time => {
  const timeArr = time.split(':');
  timeArr.pop();
  return timeArr.join(':');
});

// Game status must be a integer, current options are 2 = postponed and 3 = canceled
Vue.filter('toGameStatusString', gameStatus => {
  return gameStatus === 2 ? 'pospuesto' : gameStatus === 3 ? 'cancelado' : '';
});

// Number must be a number type
Vue.filter('toFixed2', toFixedTwoDigitsMax);

// Should be decimal, rounds 2 values
Vue.filter('fixed', value => {
  const isFloat = x => {
    return !!(x % 1);
  };
  if (isFloat(value)) {
    return value.toFixed(2);
  } else {
    return value;
  }
});

Vue.filter('secondsToHours', seconds => {
  const check = !!(seconds && !Number.isNaN(seconds));
  if (seconds === 0) {
    return '00:00:00';
  }
  if (check) {
    if (seconds > 0) {
      const hours = Math.floor(seconds / secondsInHour);
      const minutes = Math.floor((seconds - hours * secondsInHour) / 60);
      const secondsRemaining = Math.floor(seconds - hours * secondsInHour - minutes * 60);
      return `0${hours}:${minutes < 10 ? `0${minutes}` : minutes}:${
        secondsRemaining < 10 ? `0${secondsRemaining}` : secondsRemaining
      }`;
    } else {
      return '00:00:00';
    }
  }
  return seconds;
});

Vue.filter('formattedDate', (value, dateFormat) => {
  if (value && dateFormat) {
    return format(value, dateFormat, { locale: es });
  }
  return value;
});

Vue.filter('toFormattedDate2', (date, dateFormat, avoidTimeZone = false) => {
  if (date) {
    let dateAux = new Date(date);
    if (avoidTimeZone) {
      const userTimezoneOffset = dateAux.getTimezoneOffset() * 60000;
      dateAux = new Date(dateAux.getTime() + userTimezoneOffset);
    }
    return format(dateAux, dateFormat, { locale: esLocale });
  }
  return date;
});
